import { Col, Row, Space, Table } from 'antd';
import { EditButton, TextField, useTable } from '@refinedev/antd';
import { ICourseCertificate } from 'interfaces/course_certificate';
import { ISignaturePartners } from 'interfaces/signature_partners';
import { ListLayout } from '../../../components/layout/layout/ListLayout';
import { ReportKindMap } from 'services/signature-partners';

export const SignaturePartnersList = () => {
  const { tableProps } = useTable<ISignaturePartners>({});

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ListLayout title="Modelos de Assinatura">
          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="name"
              key="name"
              title="Modelo"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex={['certifier', 'name']}
              key="certifier"
              title="Instituição certificadora"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="report_kind"
              key="report_kind"
              title="Local"
              render={value => (
                <TextField
                  value={ReportKindMap[value as keyof typeof ReportKindMap]}
                />
              )}
            />
            <Table.Column<ICourseCertificate>
              title="Ações"
              dataIndex="actions"
              align="center"
              width={80}
              render={(_, record) => {
                return (
                  <Space>
                    <EditButton
                      hideText
                      size="small"
                      recordItemId={record.id}
                    />
                  </Space>
                );
              }}
            />
          </Table>
        </ListLayout>
      </Col>
    </Row>
  );
};
